import Layout from "components/layout/Layout";
import { Login, Otp, OnBoardingForm, Company, CompanyProfile, Setting} from "./components";
import RateCardNew from 'pages/company/rateCardNew/rateCardNew';

export const routeConfigAuth = [
  { path: "/", component: Login, layout: null, isAuth: false },
  { path: "/login", component: Login, layout: null, isAuth: false },
  { path: "/otp", component: Otp, layout: null, isAuth: false },
];

//Dynamic routing configuration
export const routeConfigDynamic = [
  { path: "/", component: Login, layout: null, isAuth: false },
  { path: "/login", component: Login, layout: null, isAuth: false },
  { path: "/otp", component: Otp, layout: null, isAuth: false },
  { path: '/companies', component: Company, layout: Layout, isAuth: true, moduleKey: "company" },
  { path: '/companies/new-booking', component: OnBoardingForm, layout: Layout, moduleKey: "company" },
  { path: '/companies/companyprofile/:id', component: CompanyProfile, layout: Layout, isAuth: true, moduleKey: "company" },
  { path: '/settings',component: Setting,layout: Layout, isAuth: true, moduleKey: "settings"},
  { path: '/ratecard-new', component: RateCardNew, layout: Layout, isAuth: true, moduleKey: "configuration"},
];

// Company Route config
export const routeConfigCompany = [
  { path: '/companies', component: Company, layout: Layout, isAuth: true },
  { path: '/companies/new-booking', component: OnBoardingForm, layout: Layout, isAuth: true },
  { path: '/companies/companyprofile', component: CompanyProfile, layout: Layout, isAuth: true },
];

//Admin Route config
export const routeConfigAdmin = [
  { path: "/", component: Login, layout: null, isAuth: false },
  { path: "/login", component: Login, layout: null, isAuth: false },
  { path: "/otp", component: Otp, layout: null, isAuth: false },
  { path: '/companies', component: Company, layout: Layout, isAuth: true },
  { path: '/companies/new-booking', component: OnBoardingForm, layout: Layout, isAuth: true },
  { path: '/companies/companyprofile/:id', component: CompanyProfile, layout: Layout, isAuth: true },
  {path: '/settings',component: Setting,layout: Layout, isAuth: true,},
];

// Vendor Route
export const routeConfigVendor = [
  { path: "/", component: Login, layout: null, isAuth: false },
  { path: "/login", component: Login, layout: null, isAuth: false },
  { path: "/otp", component: Otp, layout: null, isAuth: false },
  { path: '/companies', component: Company, layout: Layout, isAuth: true },
  { path: '/companies/new-booking', component: OnBoardingForm, layout: Layout, isAuth: true },
  { path: '/companies/companyprofile/:id', component: CompanyProfile, layout: Layout, isAuth: true },
  {path: '/settings',component: Setting,layout: Layout, isAuth: true,},
];

